import React from "react";
import "./PrintConsultantNotes.scss";
import moment from "moment";
import SurveyComponent from "pages/RMO/components/cancerTemplate/Template";
import defaultSurveyConfig from "pages/RMO/components/cancerTemplateForm/template";
import { MocUserRole } from "core/services/models/Enums";
import PatientDetailsPrintHeader from "components/CommonPrintComponent/PatientDetailsPrintHeader";
import testLabels from "./testLabels.json";

export default function PrintConsultantNotes({
  prescriptionPlansPrint,
  testsRequestedPrint,
  followUpData,
  consultantNotesData,
  servicesRendered,
  appointmentDetails,
  referredTos,
  patientDetail,
  notes,
  componentRef,
  origin,
  templateJSON,
  signatureData,
  signatureDetails,
  userRole,
  staffType,
  smartSummaryData,
  vital
}: any) {

  function camelCase(input: string): string {
    return input
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  return (
    <div
      className="prescriptions-print-wrapper"
      ref={componentRef}
    >
      {/* Patient Details */}
      <PatientDetailsPrintHeader
        patientData={{ patientInfo: patientDetail, vitalsData: null }}
        smartSummaryData={smartSummaryData}
        appointmentDate={appointmentDetails?.scheduleDate}
      />
      <br />
      {
        origin === "FOLLOW-UP" && (
          <>
            {/* Vitals */}
            {
              vital && (
                <>
                  <div className={`${testLabels?.some((eachKey: any) => vital[`${eachKey?.field}`]) ? "heading-primary" : "print-hidden-co heading-primary"}`}>Vitals</div>
                  <ul className="prev-cn-vital">
                    {
                      testLabels?.map((item: any, viIndex: any) => {
                        const value = vital?.[item?.field];
                        return value ? (
                          <li className="prev-cn-vital-item" key={viIndex}>
                            <span className="prev-cn-label">{item?.label}:</span>&nbsp;
                            <span>{value}</span>&nbsp;
                            <span>{item?.units}</span>&nbsp;
                          </li>
                        ) : null;
                      })
                    }
                  </ul>
                </>
              )
            }
            {/* Brief History */}
            {
              followUpData?.briefHistory && (
                <>
                  <div className="heading-primary">Brief History</div>
                  <div className="textarea-content">{followUpData?.briefHistory}</div><br />
                </>
              )
            }
            {/* Complaints */}
            {
              followUpData?.complaints && (
                <>
                  <div className="heading-primary">Complaints</div>
                  <div className="textarea-content">{followUpData?.complaints}</div><br />
                </>
              )
            }
            {/* Examination */}
            {
              followUpData?.examination && (
                <>
                  <div className="heading-primary">Examination</div>
                  <div className="textarea-content">{followUpData?.examination}</div><br />
                </>
              )
            }
            {/* Clinical Impressions */}
            {
              consultantNotesData?.clinicalImpression && (
                <>
                  <div className="heading-primary">Clinical Impressions</div>
                  <div className="textarea-content">{consultantNotesData?.clinicalImpression}</div><br />
                </>
              )
            }
          </>
        )
      }
      {
        origin !== "PHYSIOTHERAPIST" && origin !== "PSYCHOLOGIST" && (
          notes && (
            <>
              {/* Notes */}
              <div className="heading-primary">Notes</div>
              <div className="textarea-content">{notes}</div><br />
            </>
          )
        )
      }
      {
        origin === "FOLLOW-UP" && (
          <>
            {/* Prescription Pad */}
            {
              (
                !(prescriptionPlansPrint?.filter((e: any) => e?.addToPrint)?.length <= 0) &&
                (prescriptionPlansPrint?.some((outer: any) => {
                  return outer?.medicines?.some((inner: any) => inner?.medicineName);
                }))
              ) && (
                < section className="chemo-order">
                  <div className="chemo-order-details">
                    <div className="pre-medication-container">
                      <div className="prescriptions-primary-heading">
                        Prescription Pad
                      </div>
                      {prescriptionPlansPrint?.filter((e: any) => e?.addToPrint)?.length >
                        0
                        ? prescriptionPlansPrint
                          ?.filter((e: any) => e?.addToPrint && !e?.isCancelled)
                          ?.map((each: any) => {
                            return (
                              <>
                                <div className="prescriptions-secondary-heading">
                                  Prescription ID: {each?.prescriptionId}
                                </div>
                                <table className="pre-medication-table-container">
                                  <thead>
                                    <th>Type</th>
                                    <th>Medicine</th>
                                    <th>Dose</th>
                                    <th>When</th>
                                    <th>Frequency</th>
                                    <th>Duration</th>
                                    <th>Notes/Instructions</th>
                                    <th>Side Effects</th>
                                  </thead>
                                  <tbody>
                                    {
                                      each?.medicines?.length > 0 ? (
                                        each?.medicines?.map((e: any, index: any) => (
                                          <tr className="procedure-data">
                                            <td className={e?.type ? "type-pcn" : ''}>{camelCase(e?.type)}</td>
                                            <td className="med-name-pcn">{e?.medicineName}</td>
                                            <td className="dose-pcn">{e?.dose}</td>
                                            <td className={e?.when ? "when-pcn" : ''}>{e?.when}</td>
                                            <td>{e?.frequency}</td>
                                            <td>{e?.duration}</td>
                                            <td>{e?.instructions}</td>
                                            <td className={e?.selectedSideEffects?.length > 0 ? "side-effects-pcn" : ""}>
                                              <ul>
                                                {e?.selectedSideEffects?.map(
                                                  (sideEffect: any) => {
                                                    return <li>{camelCase(sideEffect)}</li>
                                                  }
                                                )}
                                              </ul>
                                            </td>
                                          </tr>
                                        ))
                                      ) : <p>NA</p>
                                    }
                                  </tbody>
                                </table>
                              </>
                            )
                          })
                        : <p>NA</p>}
                    </div>
                  </div>
                  <br />
                </section>
              )
            }
          </>
        )
      }
      {
        origin === "FOLLOW-UP" && (
          <>
            {/* Services Rendered */}
            {
              appointmentDetails?.appointmentType === "HC" && (
                < section className="chemo-order">
                  <div className="chemo-order-details">
                    <div className="pre-medication-container">
                      <div className="prescriptions-primary-heading">
                        Services Rendered
                      </div>
                      <>
                        {
                          servicesRendered?.every((service: any) => !service?.serviceTemplateName && !service?.completedBy) ?
                            <p>NA</p>
                            :
                            <table className="pre-medication-table-container">
                              <thead>
                                <th>#</th>
                                <th>Type</th>
                                <th>Completed By</th>
                              </thead>
                              <tbody>
                                {
                                  servicesRendered?.length > 0 ? (
                                    servicesRendered.map((e: any, index: any) => (
                                      <tr className="procedure-data">
                                        <td>{index + 1}</td>
                                        <td>{e?.serviceTemplateName}</td>
                                        <td>{e?.completedBy}</td>
                                      </tr>
                                    ))
                                  ) : <p>NA</p>
                                }
                              </tbody>
                            </table>
                        }
                      </>
                    </div>
                  </div>
                </section>
              )
            }
          </>
        )
      }
      {
        origin !== "PHYSIOTHERAPIST" && origin !== "PSYCHOLOGIST" && (
          <>
            {/* Tests Required */}
            {
              origin === "GENETIC_COUNSELLOR" ? (
                (
                  !(testsRequestedPrint?.filter((e: any) => e?.addToPrint)?.length <= 0)
                  &&
                  (testsRequestedPrint?.some((each: any) => each?.testName))
                ) && (
                  <section className="chemo-order">
                    <div className="chemo-order-details">
                      <div className="pre-medication-container">
                        <div className="prescriptions-primary-heading">Tests Required</div>
                        {
                          testsRequestedPrint
                            ?.filter((e: any) => e?.addToPrint)?.every((eTest: any) => (!eTest?.serviceId) && !eTest?.instructions && !eTest?.when) ?
                            <p>NA</p>
                            : (
                              <table className="pre-medication-table-container">
                                <thead>
                                  <th>Sr.No</th>
                                  <th>Test</th>
                                  <th>Instructions</th>
                                  <th>When</th>
                                </thead>
                                <tbody>
                                  {
                                    testsRequestedPrint
                                      ?.filter((e: any) => e?.addToPrint && !e?.isCancelled)
                                      ?.map((eachTest: any, outerIndex: any) => {
                                        return (
                                          <tr className="procedure-data">
                                            <td>{outerIndex + 1}</td>
                                            <td>
                                              {eachTest?.testName ? eachTest?.testName : ""}
                                            </td>
                                            <td>{eachTest?.duration}</td>
                                            <td>{eachTest?.when ? moment(eachTest?.when).format(
                                              "DD-MM-YYYY") : ""}</td>
                                          </tr>
                                        )
                                      })
                                  }
                                </tbody>
                              </table>
                            )
                        }
                      </div>
                    </div>
                    <br />
                  </section>
                )
              ) : (
                (
                  !(testsRequestedPrint?.filter((e: any) => e?.addToPrint)?.length <= 0)
                  &&
                  (testsRequestedPrint?.some((outer: any) => {
                    return outer?.tests?.some((inner: any) => inner?.testName);
                  }))
                ) && (
                  <section className="chemo-order">
                    <div className="chemo-order-details">
                      <div className="pre-medication-container">
                        <div className="prescriptions-primary-heading">Tests Required</div>
                        {testsRequestedPrint?.filter((e: any) => e?.addToPrint)?.length > 0
                          ? testsRequestedPrint
                            ?.filter((e: any) => e?.addToPrint && !e?.isCancelled)
                            ?.map((eachTest: any, outerIndex: any) => {
                              return (
                                <>
                                  {/* <div className="prescriptions-secondary-heading">
                              Integration Order ID: {eachTest?.integrationOrderId}
                            </div> */}
                                  {
                                    eachTest?.tests?.every((eTest: any) => (!eTest?.serviceId) && !eTest?.instructions && !eTest?.when) ?
                                      <p>NA</p>
                                      :
                                      <table className="pre-medication-table-container">
                                        <thead>
                                          <th>Sr.No</th>
                                          <th>Test</th>
                                          <th>Instructions</th>
                                          <th>When</th>
                                        </thead>
                                        <tbody>
                                          {
                                            eachTest?.tests?.length > 0 ? (
                                              eachTest?.tests?.map((e: any, index: any) => (
                                                <tr className="procedure-data">
                                                  {/* {JSON.stringify(values)} */}
                                                  <td>{index + 1}</td>
                                                  <td>
                                                    {e?.testName ? e?.testName :
                                                      e?.serviceId?.label
                                                        ? e?.serviceId?.label
                                                        : e?.serviceId
                                                          ? e?.serviceId
                                                          : ""}
                                                  </td>
                                                  <td>{e?.instructions}</td>
                                                  <td>{e?.when && moment(e?.when).format(
                                                    "DD-MM-YYYY")}</td>
                                                </tr>
                                              ))
                                            ) : <p>NA</p>
                                          }
                                        </tbody>
                                      </table>
                                  }
                                </>
                              )
                            })
                          : <p>NA</p>}
                      </div>
                    </div >
                    <br />
                  </section >
                )
              )
            }
          </>
        )
      }
      {/* Advice */}
      {
        followUpData?.advice && (
          <>
            <div className="heading-primary">Advice</div>
            <div className="textarea-content">{followUpData?.advice}</div><br />
          </>
        )
      }
      {/* Next Visit */}
      {
        (followUpData?.nextVisit || followUpData?.nextVisit1 || followUpData?.nextVisit2) && (
          <>
            <div className="heading-primary">Next Visit</div>
            {
              (followUpData?.nextVisit === "" && (followUpData?.nextVisit1 !== "" || followUpData?.nextVisit2 !== "")) ? (
                <div className="textarea-content">{followUpData?.nextVisit1 + " " + followUpData?.nextVisit2}</div>
              )
                :
                followUpData?.nextVisit !== "" ?
                  (
                    <div className="textarea-content">{followUpData?.nextVisit && moment(followUpData?.nextVisit).format("DD-MM-YYYY")}</div>
                  )
                  :
                  null
            }
          </>
        )
      }
      {/* Referred To */}
      {
        referredTos?.some((r: any) => (r?.doctorName && r?.doctorName !== "Others") || (r?.doctorName === "Others" && r?.doctorNameOthers)) && (
          <>
            <div className="heading-primary">Referred To</div>
            <div>
              {
                referredTos?.every((r: any) => !r?.doctorName && !r?.doctorNameOthers && !r?.speciality && !r?.phoneNo && !r?.emailId) ?
                  <p>NA</p>
                  :
                  referredTos?.map((referedTo: any, index: any) => (
                    < table className="refered-to-table-container">
                      <thead>
                        <th>Consultant Name</th>
                        {
                          referedTo?.speciality && (
                            <th>Speciality</th>
                          )
                        }
                        {
                          referedTo?.phoneNo && (
                            <th>Phone No</th>
                          )
                        }
                        {
                          referedTo?.emailId && (
                            <th>Email ID</th>
                          )
                        }
                      </thead>
                      <tbody>
                        <tr className="procedure-data">
                          <td>
                            {
                              referedTo?.doctorName === "Others" ?
                                referedTo?.doctorNameOthers ? referedTo?.doctorNameOthers : ""
                                :
                                referedTo?.doctorName
                            }
                          </td>
                          {
                            referedTo?.speciality && (
                              <td>{referedTo?.speciality}</td>
                            )
                          }
                          {
                            referedTo?.phoneNo && (
                              <td>{referedTo?.phoneNo}</td>
                            )
                          }
                          {
                            referedTo?.emailId && (
                              <td>{referedTo?.emailId}</td>
                            )
                          }
                        </tr>
                      </tbody>
                    </table>
                  ))
              }
            </div>
            <br />
          </>
        )
      }
      {/* {
        origin === "GENETIC_COUNSELLOR" &&
        <div className="heading-primary">Genetic Counsellor</div>
      } */}
      {
        origin === "GENETIC_COUNSELLOR" || origin === "PHYSIOTHERAPIST" || origin === "PSYCHOLOGIST" ? (
          <>
            <SurveyComponent
              css={defaultSurveyConfig.defaultSurveyCSS}
              data={signatureData}
              json={templateJSON}
              onComplete={(survey: any) => { }}
              hideDot={true}
            />
            <br />
          </>
        ) : null
      }
      {
        (staffType === MocUserRole.HOME_CARE_RMO ||
          staffType === MocUserRole.HOME_CARE_NURSE ||
          userRole === MocUserRole.HOME_CARE_RMO ||
          userRole === MocUserRole.HOME_CARE_NURSE) && (
          <>
            <div className="heading-primary">Signature Details</div>
            <div className='row'>
              <div className="col-md-3 heading-primary-text">Name</div>
              <div className="col-md-3 heading-primary-text">Date/Time</div>
              <div className="col-md-3 heading-primary-text">Emp Code</div>
            </div>
            <div className='row'>
              <div className="col-md-3 textarea-content">{signatureDetails?.name}</div>
              <div className="col-md-3 textarea-content">
                {signatureDetails?.dateTime
                  ? moment(signatureDetails?.dateTime).format(
                    "DD-MM-YYYY / HH:mm a"
                  )
                  : ""}
              </div>
              <div className="col-md-3 textarea-content">{signatureDetails?.empCode}</div>
            </div>
            <SurveyComponent
              css={defaultSurveyConfig.defaultSurveyCSS}
              data={signatureData}
              json={templateJSON}
              onComplete={(survey: any) => { }}
              hideDot={true}
            />
          </>
        )
      }
      {
        origin === "FOLLOW-UP" && (staffType !== MocUserRole.HOME_CARE_RMO &&
          staffType !== MocUserRole.HOME_CARE_NURSE &&
          userRole !== MocUserRole.HOME_CARE_RMO &&
          userRole !== MocUserRole.HOME_CARE_NURSE) && (
          <>
            <div className="heading-primary">Signature Details</div>
            <div className='row'>
              <div className="col-md-3 heading-primary-text">Name</div>
              <div className="col-md-3 textarea-content">
                {signatureDetails?.name}
              </div>
            </div>
            <div className='row'>
              <div className="col-md-3 heading-primary-text">Date/Time</div>
              <div className="col-md-3 textarea-content">
                {signatureDetails?.dateTime
                  ? moment(signatureDetails?.dateTime).format(
                    "DD-MM-YYYY / HH:mm a"
                  )
                  : ""}
              </div>
            </div>
            <SurveyComponent
              css={defaultSurveyConfig.defaultSurveyCSS}
              data={signatureData}
              json={templateJSON}
              onComplete={(survey: any) => { }}
              hideDot={true}
            />
          </>
        )
      }
    </div >
  )
}
